import { __export } from "./chunk-QK4PKNB3.mjs"; // src/constants/sentry.ts

var sentry_exports = {};

__export(sentry_exports, {
  sentryConfig: function sentryConfig() {
    return _sentryConfig;
  }
});

var _sentryConfig = {
  org: "cofit"
};
export { _sentryConfig as sentryConfig, sentry_exports };